import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Pipe({
  name: 'remainingTime'
})
export class RemainingTimePipe implements PipeTransform {

  private offset: string = '0';

  constructor(private translate: TranslateService) {
    this.offset = this.translate.instant('Miscellaneous.time-label.utcOffset');
  }

  /**
   * @description Dado una fecha objetivo, retorna la diferencia en días y horas
   * @param targetDate Fecha objetivo
   * @param hoursOnly Si true, retorna días + horas. Si false, retorna solo días.
   * @returns Cadena con la diferencia en días y horas en formato "Xd Yh"
   */
  transform(targetDate: string | Date, hoursOnly: boolean = true): string {
    if (hoursOnly) {
      const target = moment(targetDate).utcOffset(this.offset, true);
      const now = moment().utcOffset(this.offset);
      const diffMs = target.diff(now);
      if (diffMs <= 0) return '0d 0h';

      const duration = moment.duration(diffMs);
      const days = Math.floor(duration.asDays());
      const hours = duration.hours();

      return `${days}d ${hours}h`;
    }

    const today = moment().startOf('day');
    const targetDay = moment(targetDate).startOf('day');
    const diffDias = Math.abs(targetDay.diff(today, 'days'));
    if (diffDias < 1) return '0d';

    return `${diffDias}d`;
  }

}
